export default __webpack_public_path__ + "static/media/initative-2.16f719e2.avif";